'use client'

import { useBreakpoints } from '@inflow/ui/lib/useBreakpoints'
import { ThemeToggle } from '@inflow/ui-blocks'
import { useAtomValue } from 'jotai'
import { MoonStar, SunMedium } from 'lucide-react'
import { motion } from 'motion/react' // Import motion
import Link from 'next/link'
import { isNavHiddenAtom } from '../../state/header'
import Logo from '../Logo'
import { MobileMenu } from './MobileMenu'
import Navigation from './Navigation'

export default function Header() {
  const { lg } = useBreakpoints()
  const isNavHidden = useAtomValue(isNavHiddenAtom)

  return (
    <motion.header
      // 1. Define the animation variants
      variants={{
        visible: { y: 0 },
        hidden: { y: '-100%' },
      }}
      // 2. Set the state based on the atom
      initial="visible"
      animate={isNavHidden ? 'hidden' : 'visible'}
      // 3. Tweak transition for a smooth, natural feel
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      className="fixed z-20 mx-auto flex h-14 w-full items-center justify-between bg-background px-4 md:h-16 md:px-8"
    // Note: Added z-20 to ensure it sits above the page content when visible.
    // Removed max-w-hero/mx-auto from the fixed wrapper if you want the *bar* full width,
    // but kept the inner formatting consistent with your design.
    >
      {/* Optional: Container to keep content centered if the header bar is full width */}
      <div className="mx-auto flex w-full max-w-hero items-center justify-between">
        <Link href="/">
          <Logo />
        </Link>
        {lg ? (
          <div className="flex gap-1 justify-self-end">
            <Navigation />
            <ThemeToggle
              darkContent={<SunMedium />}
              lightContent={<MoonStar />}
              className="ml-2"
            />
          </div>
        ) : (
          <div className="flex gap-1 justify-self-end">
            <ThemeToggle
              darkContent={<SunMedium />}
              lightContent={<MoonStar />}
              className="ml-2"
            />
            <MobileMenu />
          </div>
        )}
      </div>
    </motion.header>
  )
}
